import { TFunction } from 'i18next';
import { z } from 'zod';

import i18n from '@/core/i18n';
import { duplicateNameRefinement } from '@/modules/onboarding/common/utils/duplicate-name-refinement';

export const getClientsSchema = function (t: TFunction) {
  return z.object({
    entities: z
      .array(
        z.object({
          fullName: z
            .string()
            .min(1, i18n.t('authenticated.onboarding.clients:validation.name.required')),
        })
      )
      .min(1)
      .superRefine(
        duplicateNameRefinement(
          e => e.fullName,
          'fullName',
          i18n.t('authenticated.onboarding.clients:validation.name.duplicate')
        )
      ),
  });
};

export type ClientsFormData = z.infer<ReturnType<typeof getClientsSchema>>;
